export const slides = [
  {
    id: "slide-1",
    kicker: "焦点专题 · 定档",
    title: "潮汐之间",
    summary:
      "吴梦梦一人分饰母女两角，用同一张脸演出两种命运。12 月 24 日，潮声会替她们说出所有没说出口的话。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20artwork%20of%20a%20lone%20woman%20in%20a%20long%20coat%20walking%20along%20a%20rain-soaked%20harbor%20at%20dusk%2C%20deep%20navy%20blue%20sky%20with%20warm%20orange%20horizon%20glow%2C%20reflective%20wet%20pavement%2C%20film%20grain%2C%20dramatic%20atmospheric%20light%2C%20editorial%20poster%20art%2C%20no%20text%2C%20no%20watermark&width=1600&height=900&seq=slide-01&orientation=landscape",
    to: "/works/chaoxi-zhijian",
    cta: "查看作品详情",
  },
  {
    id: "slide-2",
    kicker: "新剧开机 · 年代群像",
    title: "长夜将明",
    summary:
      "一本账册，一座丝厂，一个只想守住工作的女会计。吴梦梦首次挑战年代群像剧，正在江南拍摄中。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20artwork%20of%20a%201930s%20textile%20factory%20hall%20at%20night%20with%20warm%20orange%20hanging%20lamps%20and%20deep%20navy%20blue%20shadows%2C%20dust%20suspended%20in%20light%20beams%2C%20film%20grain%2C%20atmospheric%20period%20drama%20poster%20art%2C%20no%20text%2C%20no%20watermark&width=1600&height=900&seq=slide-02&orientation=landscape",
    to: "/news/changye-kaiji",
    cta: "阅读开机报道",
  },
  {
    id: "slide-3",
    kicker: "演员动态 · 影展",
    title: "亚洲电影展推广大使",
    summary:
      "第 26 届亚洲电影展宣布吴梦梦担任推广大使，她将携《潮汐之间》参与「亚洲新声」单元展映。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20an%20empty%20grand%20cinema%20auditorium%20with%20deep%20navy%20blue%20seats%20and%20a%20glowing%20warm%20orange%20screen%2C%20light%20haze%20in%20the%20air%2C%20film%20grain%2C%20elegant%20editorial%20atmosphere%2C%20no%20text%2C%20no%20watermark&width=1600&height=900&seq=slide-03&orientation=landscape",
    to: "/news/dianyingzhan-dashi",
    cta: "查看动态",
  },
];